// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__26gr1","control":"Checkout_control__2qGfb","actions":"Checkout_actions__2X_6_","submit":"Checkout_submit__2BFZZ","invalid":"Checkout_invalid__2gAN9"};